var _mask, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBagReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_392_56",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 12L17.8383 9.49026C17.4633 8.82366 17.945 8 18.7098 8H24.2902C25.055 8 25.5367 8.82366 25.1617 9.49026L23.75 12"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3784 12.4903C18.6492 12.9716 19.2589 13.1423 19.7403 12.8716C20.2216 12.6008 20.3923 11.9911 20.1216 11.5097L18.3784 12.4903ZM22.8784 11.5097C22.6077 11.9911 22.7784 12.6008 23.2597 12.8716C23.7411 13.1423 24.3508 12.9716 24.6216 12.4903L22.8784 11.5097ZM25.1617 9.49026L24.2902 9L25.1617 9.49026ZM17.8383 9.49026L18.7098 9L17.8383 9.49026ZM20.1216 11.5097L18.7098 9L16.9667 9.98052L18.3784 12.4903L20.1216 11.5097ZM18.7098 9H24.2902V7H18.7098V9ZM24.2902 9L22.8784 11.5097L24.6216 12.4903L26.0333 9.98052L24.2902 9ZM24.2902 9H24.2902L26.0333 9.98052C26.7832 8.64731 25.8198 7 24.2902 7V9ZM18.7098 9L18.7098 9V7C17.1802 7 16.2168 8.64731 16.9667 9.98052L18.7098 9Z",
    fill: "#161616",
    mask: "url(#path-1-inside-1_392_56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.55 12.5H23.45C23.4609 12.5118 23.4723 12.5242 23.4843 12.5373C23.5997 12.6631 23.7654 12.8474 23.9647 13.0791C24.3637 13.543 24.8949 14.1941 25.4251 14.9438C25.9562 15.695 26.4797 16.536 26.8688 17.3802C27.2605 18.23 27.5 19.0488 27.5 19.7647C27.5 20.7214 27.1499 21.6256 26.2718 22.3051C25.3766 22.998 23.8766 23.5 21.5 23.5C19.1234 23.5 17.6234 22.998 16.7282 22.3051C15.8501 21.6256 15.5 20.7214 15.5 19.7647C15.5 19.0488 15.7395 18.23 16.1312 17.3802C16.5203 16.536 17.0438 15.695 17.5749 14.9438C18.1051 14.1941 18.6363 13.543 19.0353 13.0791C19.2346 12.8474 19.4003 12.6631 19.5157 12.5373C19.5277 12.5242 19.5391 12.5118 19.55 12.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5H13.5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5L14 16.5L9 21.5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagReceive);
export default __webpack_public_path__ + "static/media/BagReceive.3fbc60551074d6b961256bc79aad3094.svg";
export { ForwardRef as ReactComponent };